const { ViewMode } = require("./public-types");

const DateSetup = {
    dates: [],
    viewMode: ViewMode
};

module.exports = { DateSetup };
